import { ComboBox, TextField } from "@fluentui/react";
import React from "react";
export const XComboBox = (props) => {
    if (props.isError)
        return React.createElement(TextField, { label: props.label || '', readOnly: props.readonly || false, value: 'Error...' });
    if (props.isLoading)
        return React.createElement(TextField, { label: props.label || '', readOnly: props.readonly || false, value: 'Loading...' });
    return React.createElement(ComboBox, { disabled: props.disabled || false, errorMessage: props.errorMessage || '', label: props.label || '', title: props.label || '', onChange: (_, value) => {
            if (props.onChange != null)
                props.onChange(value === null || value === void 0 ? void 0 : value.key, value);
        }, options: props.options || [], required: props.required || false, useComboBoxAsMenuWidth: true, selectedKey: props.value || '' });
};
